import { Alert, Flex } from 'front-commons/ds';
import { Typography } from 'hype-ds';
import type { HandleCheckDistributorAttributionProps } from 'stores/pos/interfaces';

export default function BUAttributionMissing({
	invalidBUs,
	allInvalid,
	hasValidIndustry,
}: Concrete<Pick<HandleCheckDistributorAttributionProps, 'invalidBUs' | 'hasValidIndustry'>> & {
	allInvalid: boolean;
}) {
	return (
		<Flex gap="8px" direction="column">
			<Typography.Paragraph.M color="--text-primary" whiteSpace="pre-line">
				{allInvalid
					? 'Para acessar os produtos da loja, selecione distribuidores para '
					: 'Você ainda não selecionou distribuidores para: '}
				<Typography.Label.M color="--text-primary">
					{invalidBUs.map((bu) => `Hypera ${bu.name}`).join(' e ')}.
				</Typography.Label.M>

				{!allInvalid && `\nSem essa etapa, não é possível visualizar ou comprar os produtos.`}
			</Typography.Paragraph.M>

			{hasValidIndustry && allInvalid && (
				<Typography.Paragraph.M color="--text-primary">
					As demais indústrias já virão pré-configuradas e{' '}
					<Typography.Label.M color="--text-primary">podem ser personalizadas a qualquer momento.</Typography.Label.M>
				</Typography.Paragraph.M>
			)}

			{allInvalid && (
				<Alert type="warn" toastMode preserveMobileRadius containerProps={{ marginTop: '8px' }}>
					Os produtos só serão exibidos após a seleção de distribuidores.
				</Alert>
			)}
		</Flex>
	);
}
